const isExternalUrl = (url = "") =>
  url.startsWith("//") || url.startsWith("http") || url.startsWith("www");

export default isExternalUrl;
